<template>
  <div class="modify-nickname" :class = "{'clear-header':isWechatBrowser}">
    <my-header v-if="!isWechatBrowser" class="top-title" title="修改昵称" :showBack="true"></my-header>
      <div style="background-color: #f3f8fc;height: 0.88rem;width: 6.9rem;font-size: 0.28rem;margin: 0 auto">
        <input v-model="nickname" class="mint-field-core info-input" style="width: 90%">
      </div>
    <div class="btn-save" @click="saveNickname">保存</div>
  </div>
</template>

<script>
  import { Toast } from 'mint-ui'
  import Header from '../../components/header/Header'
  import userService from '../../service/customer/UserService'

  export default {
    name: 'ModifyNickname',
    components: {
      'my-header': Header,
    },
    data () {
      return {
        customerUser:{},
        nickname:'',
        isWechatBrowser:this.$verfyBrowserType(),
      }
    },
    beforeMount () {
      document.title = this.$route.meta.title;
      this.getCustomerUserInfo();
    },
    methods: {
      async getCustomerUserInfo(){
        let result=await userService.getUserInfo();
        if(result.code == '0'){
          this.customerUser = result.data;
          this.nickname = this.customerUser.nickname;
        }else {
          Toast('获取客户信息失败');
        }
      },
      async saveNickname(){
        let result = await userService.modifyInfo(this.nickname);
        if(result.code == '0'){
          Toast('修改成功');
          this.$router.go(-1);
        }
      }
    }
  }
</script>
<style lang="scss">
  @import '../../assets/style/common.scss';
  .modify-nickname{
    height: 100vh;
    background: white;
    padding-top: 0.3rem;

    .info-input{
      color:#878e99;
      background-color: #f3f8fc;
      margin-top: 0.25rem;
    }
  }
  .btn-save{
    width: 6.94rem;
    height: 0.92rem;
    line-height: 0.92rem;
    border-radius: 0.44rem;
    margin: 8.2rem auto 0rem auto;
    text-align: center;
    font-size: 0.36rem;
    color: white;
    background-color: #ff7544;
  }
</style>
